import "./index.css";
import plusicon from "../../assets/shapes_svg/roledetail/plusicon.svg";

const Add = ({ header, style, click }) => {
  return (
    <>
      <div
        onClick={click}
        className={
          "option__icon add__icon " +
          (style === "product" ? "add__icon__product" : "")
        }
      >
        <h4 style={{ maxWidth: "90px" }}>{header}</h4>
        <img className="" src={plusicon} alt="" />
      </div>
    </>
  );
};

export default Add;
